import { shape } from 'prop-types'
import React from 'react'

const Card = (props) => (
  <a className="card" href={props.venue.url}>
    <div className="image">
      <img src={props.venue.image} />
    </div>
    <div className="info">
      <div className="site-building">{props.venue.site_building}</div>
      <div className="venue">{props.venue.name}</div>
    </div>
  </a>
)
Card.propTypes = {
  venue: shape({}).isRequired,
}

export default Card
